import { InitClient,GetByParas,Post,PostWithParas,PostNoParas } from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

async function RAPInformationsAdd(obj) {
  var data = await PostWithParas("d2a806dc-f67c-4e96-921c-fcc65e93b54b", "", obj);
  if (data.Result == 200) {
    return data;
  } else {
    return false;
  }
}

async function GetRAPFlowSendNextSteps(userid, stepid, instanceid) {
  var paras = {
    userid: userid,
    flowid: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    stepid: stepid,
    instanceid: instanceid
  };
  return await GetByParas("6704feb2-2301-4f60-ab98-4ffb0e3215f0", paras);
}


/**
 * 添加需求流程审批
 * @param {*} paras 
 */
async function RAPExcuteflow(paras) {
  var data = await Post("57871b3f-7b02-4179-9b3e-c40d44ff7eeb", paras);
  // data = data.replace("\"", "");
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}

async function GetCCUser(userid, pageIndex, pageSize) {
  var paras = {
    userid: userid,
    flowId: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "624b3e63-9aac-46b1-97cd-e76d7e57facd",
    paras,
    []
  );
  return data;
}

/**
 * 获取步骤时间线
 * @param {*} userid 
 * @param {*} instanceid 
 */
async function GetStepTimeLine(userid, instanceid) {
  var paras = {
    userid: userid,
    flowId: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    stepid: "f98ba941-ba98-464d-859f-c9252b2dc075",
    instanceid: instanceid
  };
  return await GetByParas("2aa9da6e-aaec-4987-bcc9-fb0120aa1659", paras);
}

/**
 * 获取需求流程编号
 */
async function GetNeedNo() {
  var paras = {};
  return await GetByParas("11ac4a8e-840e-40fb-964a-3c57e343e1ff", paras);
}

async function GetNeedFlowByMine(userId) {
  var paras = {
    userId : userId
  };
  var data = await PostWithParas("3f3299a6-e0fc-4eb1-a579-5bcffc01c9e6",paras,"");
  if (data.Result == 200) {
    return data;
  } else {
    return false;
  }
}

async function GetUserCeate(userid, pageIndex, pageSize, searchInstance) {
  var paras = {
    userid: userid,
    flowId: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "90e7857c-8bd3-4e00-aaa7-31f2af071941",
    paras,
    searchInstance
  );
  return data;
}

/**
 * 我处理的审批(我已审批)
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} Instance 
 */
async function GetUserDeal(userid, pageIndex, pageSize, Instance) {
  var paras = {
    userid: userid,
    flowId: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "3aed5420-68cb-42e6-9b21-f9ebe2b20edd",
    paras,
    Instance
  );
  return data;
}

//获取我发起的需求id列表
async function GetNeedFlowMeList(userId) {
  var paras = {
    userId: userId
  };
  return await GetByParas("91700e2d-5064-4fa3-ab05-7dd5516babec", paras);
}

///获取需求流程详情
async function GetNeedDtail(id) {
  var paras = {
    id: id
  };
  return await GetByParas("f74dcddd-2de7-4ff5-b0de-f681429b959d", paras);
}

/**
 * 查询所有需求的申请
 */
async function GetNeedFlowList() {
  return await GetByParas("8A460E7D-2EA3-4814-BF30-078E94191598", {});
}

/**
 * 获取待办事项(待审批)
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} Instance 
 */
async function GetRAPWaitTasks(userid, pageIndex, pageSize, Instance) {
  var paras = {
    userid: userid,
    flowId: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "f1001200-1c14-4e68-ba05-388dad7857f1",
    paras,
    Instance
  );
  return data;
}

//撤销需求流程
async function UpdateRAPStatus(id) {
  var paras = {
    id: id
  };
  return await GetByParas("46979722-dbf0-488b-b16b-c73fd368d927", paras);
}


//拒绝
async function RAPRefuse(paras) {
  var data = await Post("edbe46b4-577d-468c-9bb0-ab192eb251d5", paras);
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}

//完成
async function RAPFinshflow(paras) {
  var data = await Post("4b5029d6-fbd8-48bf-9395-3704f16a70ec", paras);
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}
//转交
async function RAPHandOverOper(userName, ReceiveName, taskid, userid, reason) {
  var paras = {
    userName: userName,
    ReceiveName: ReceiveName,
    taskid: taskid,
    userid: userid,
    reason: reason
  };
  return await GetByParas("550c7247-5e6d-41d0-b10d-047975087739", paras);
}

async function Cancel(taskid, flowid, instanceid, stepid) {
  var paras = {
    taskid: taskid,
    flowid: flowid,
    instanceid: instanceid,
    stepid: stepid
  };
  var data = await PostWithParas(
    "fab77c72-fd00-4796-bc07-3a433b538aea",
    paras,
    ""
  );
  if (data.result == 1) {
    return data;
  } else {
    return false;
  }
}

//更新数据
async function UpdateData(needworkflow) {
  var data = await PostWithParas("3ACA1376-C1CB-456C-8189-52F62880583E",{},needworkflow);
  // if (data.result == 1) {
  //   return data;
  // } else {
  //   return false;
  // }
  return data;
}

export {
  RAPInformationsAdd,
  GetStepTimeLine,
  GetNeedNo,
  GetNeedFlowByMine,
  GetNeedFlowMeList,
  GetUserCeate,
  GetNeedDtail,
  GetCCUser,
  GetRAPWaitTasks,
  GetRAPFlowSendNextSteps,
  UpdateRAPStatus,
  RAPExcuteflow,
  GetNeedFlowList,
  GetUserDeal,
  RAPHandOverOper,
  RAPFinshflow,
  RAPRefuse,
  Cancel,
  UpdateData
};
